import { get, post, del } from 'utils/methods';

export function getLogisticApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}items`, data, headers);
}

export function commentLogisticApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order-item/comment`, data, headers);
}

export function toggleLogisticApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/order-item/change-state`, data, headers);
}

export function createLogisticJobApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/logistics/job`, data, headers);
}

export function createLabelApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/logistics/label`, data, headers);
}

export function generatePackingNoteApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/logistics/generate-picking-note`, data, headers);
}

export function deleteLogisticLabelApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_ORDERS}commands/logistics/label`, data, headers);
}

export function sendDemandConvocationTNTApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/logistics/generate-shipment`, data, headers);
}

export function getTNTDocumentsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}logistics/shipments-files`, data, headers);
}

export function getTNTLabelApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}items`, data, headers);
}
